import React from "react"
import PropTypes from "prop-types"


class WritingLanguageChoices
 extends React.Component {

   constructor(props) {
     super(props)

     this.buttonText = this.buttonText.bind(this)
     this.renderLanguageOptions = this.renderLanguageOptions.bind(this)
     this.languageStyle = this.languageStyle.bind(this)
     this.allButton = this.allButton.bind(this)
   }

   buttonText(lang) {
     if(this.props.selectedLanguage === lang.id) {
       return `${lang.native}`
     }
       return `${lang.locale}`
   }

   renderLanguageOptions() {
     return this.props.languages.map((lang, index) => {
       return(
         <div key={index} style={this.languageStyle(lang.id)} onClick={() => this.props.onClick(lang)}>
           <h4 className={this.props.selectedLanguage === lang.id ? 'white' : "lightBlue"}>{this.buttonText(lang)}</h4>
         </div>
       )
     })
   }

   languageStyle(id) {
     return {
       display: 'flex',
       borderRadius: 30,
       backgroundColor: this.props.selectedLanguage === id ? '#03a9f4' : '#fff',
       border: '#03a9f4 solid 1px',
       justifyContent: 'center',
       alignItems: 'center',
       marginLeft: 10,
       marginRight: 10,
       cursor: 'pointer',
       flex: '0 0 auto',
       padding: 10,
     }
   }

   allButton() {
       return(
         <div style={this.languageStyle('')} onClick={this.props.onAllClick}>
           <h4 className={this.props.selectedLanguage === '' ? 'white' : 'lightBlue'}>All</h4>
         </div>
       )
   }

   render() {
     return(
       <div style={{display: 'flex', flexDirection: 'row', marginTop: 20, marginBottom: 20, overflow: 'scroll', whiteSpace: 'nowrap', justifyContent: 'center', alignItems: 'center', paddingRight: 5, paddingLeft: 5}}>
         {this.allButton()}
         {this.renderLanguageOptions()}
       </div>
     )
   }



}

export default WritingLanguageChoices;
